// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../types';
import userActions from '../../../../actions/userActions';
import { statusSelector, usersListSelector, usersEntitiesSelector } from '../../../../selectors/usersSelectors';
import Users from '../Users';
import type { Props } from '../Users';

type OwnProps = $ReadOnly<{
    userType: $PropertyType<Props, 'userType'>
}>;

const mapStateToProps = (state: State) => {
    return {
        list: usersListSelector(state),
        entities: usersEntitiesSelector(state),
        status: statusSelector(state)
    };
};

const mapDispatchToProps = {
    createUser: userActions.createUser,
    updateUser: userActions.updateUser
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(Users);